var itIT = {
  locale: 'it_IT',
  direction: 'ltr',
  date: {
    defaultFormat: {
      week: 'WW/YYYY',
      date: 'DD/MM/YYYY',
      month: 'MM/YYYY',
      year: 'YYYY',
      time: 'HH:mm:ss',
      dateTime: 'DD/MM/YYYY HH:mm:ss'
    },
    startDay: 0,
    shortMonthList: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
    monthList: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Aug', 'Set', 'Ott', 'Nov', 'Dic'],
    shortDayList: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
    dayList: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
    shortestDayList: ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa']
  },
  'dynamic-date': {
    day: 'Giorno',
    week: 'Settimana',
    month: 'Mese',
    quarter: 'Trimestre',
    year: 'Anno',
    before: 'Prima ${value}${unit}'
  },
  'auto-complete.empty': 'Nessun dato',
  'select.selected-count': '${count} articoli selezionati',
  'date-time-picker.date': 'Seleziona data',
  'image-view.zoom-out': 'Riduci',
  'input.placeholder': 'Inserire',
  'empty.text': 'Nessun dato',
  'date-picker.cancel': 'Annulla',
  'date-picker.end': 'Ora di fine',
  'cascader.empty': 'Nessun dato',
  'upload.drop': 'Trascina i file qui o',
  'color.custom': 'Personalizza colore',
  'cascader.titles': ['Livello 1', 'Livello 2', 'Livello 3', 'Livello 4', 'Livello 5', 'Livello 6', 'Livello 7', 'Livello 8'],
  'date-comparison.error-target': 'Seleziona ora di fine per il confronto',
  'transfer.empty': 'Nessun dato',
  'select.search.placeholder': 'Inserire',
  'upload.click': 'Fare clic per caricare',
  'date-time-picker.placeholder': 'Inserire',
  'pager.jump': 'Reindirizza',
  'tree-select.placeholder': 'Inserire',
  'dynamic-date.interval': 'Intervallo',
  'modal.cancel': 'Annulla',
  'image-view.rotate': 'Ruota',
  'tabs.more': 'Altro',
  'popover.ok': 'Conferma',
  'transfer.placeholder': 'Inserire',
  'date.month': 'Mese',
  'select.selected': 'Selezionato',
  'popover.cancel': 'Annulla',
  'image-view.prev': 'Precedente',
  'table.emptyText': 'Nessun dato',
  'date-time-picker.ok': 'Conferma',
  'table.filter.confirm': 'Conferma',
  'tree-select.empty': 'Nessun dato',
  'dynamic-date.fixed-date': 'Data fissa',
  'date-comparison.compare': 'Confronta',
  'auto-complete.placeholder': 'Inserire',
  'time-picker.placeholder': "Seleziona l'ora",
  'date.month-first': true,
  'select.clear': 'Cancella',
  'date.year': '${year}',
  'date-comparison.yoy': "Questo periodo l'anno scorso",
  'image-view.zoom-to-origin': 'Origine',
  'schedule.title': 'Data/Ora',
  'schedule.clear': 'Cancella',
  'date-time-picker.end': 'Seleziona data e ora di fine',
  'dynamic-date.customize': 'Personalizza',
  'date-picker.apply': 'Applica',
  'schedule.selected': 'Ora selezionata',
  'dynamic-date.dynamic-date': 'Data dinamica',
  'select.placeholder': 'Selezionare',
  'schedule.separator': ',',
  'cascader.search': 'Inserire',
  'date-picker.invalid-range': "L'intervallo di tempo selezionato supera l'intervallo selezionabile. Selezionarne uno valido.",
  'dynamic-date.date-preview': 'Anteprima della data',
  'select.empty': 'Nessun dato',
  'image-view.next': 'Successiva',
  'date-time-picker.now': 'Ora',
  'date-time-picker.time': "Seleziona l'ora",
  'tree.empty': 'Nessun dato',
  'pager.total': '${total} record in totale',
  'image-view.zoom-in': 'Ingrandisci',
  'date-picker.placeholder': 'Seleziona data',
  'textarea.placeholder': 'Inserire',
  'date.week': 'Settimana',
  'pager.size': '${count} record/pagina',
  'modal.ok': 'Conferma',
  'date-picker.start': 'Ora di inizio',
  'table.filter.reset': 'Reimposta',
  'image-view.zoom-to-fit': 'Adatta',
  'pager.page.placeholder': 'Inserire',
  'select.select-all': 'Seleziona tutto',
  'list-viewer.empty': 'Nessun dato',
  'date-comparison.compare-text': 'VS',
  'transfer.source': 'Elenco delle fonti',
  'date-time-picker.start': 'Selezionare data e ora di inizio',
  'date-comparison.error-source': 'Selezionare ora di inizio per il confronto',
  'upload.error.overflow-count': 'Numero massimo di file superato',
  'date-comparison.placeholder': 'Ora di inizio - Ora di fine',
  'time-range-picker.placeholder': 'Ora di inizio - Ora di fine',
  'date-comparison.mom': 'Rispetto al periodo precedente',
  'transfer.target': 'Elenco degli obiettivi'
};
export default itIT;